import { DataCollectionFreq } from "interfaces/dataInterfaces"
import { marketpricesApi } from "./marketpricesApi"

export const dataCollectionFreqApi = marketpricesApi.injectEndpoints({
  endpoints: builder => ({
    getDCF: builder.query<DataCollectionFreq[], { skip?: number; top?: number }>({
      query: ({ skip, top }) => ({
        url: "DataCollectionFrequencies/Get",
        method: "GET",
        params: { skip, top },
      }),
      providesTags: ["DataCollectionFreq"],
    }),
  }),
})

export const { useGetDCFQuery } = dataCollectionFreqApi
